import { ErrorlessRepository as axios } from '../../../repositories/Repository';

/**
 * fetchUser gets the user from the server, if not already
 * loaded into memory.
 */
export const fetchUser = async ({commit, state}) => {
  if (state.user) {
    return;
  }

  const res = await axios.get('/me');

  commit('setUser', res.data);
};
